import _get from 'lodash/get';
function getZipCodes(dataLayer, fallbackValue) {
  if (fallbackValue === void 0) {
    fallbackValue = '';
  }
  let searchZip = _get(dataLayer, 'search.zipCode', '');
  let userZip = _get(dataLayer, 'user.zipCode', '');

  // Set fall back to query
  if (!searchZip) {
    searchZip = fallbackValue;
  }
  if (!userZip) {
    userZip = fallbackValue;
  }
  return {
    searchZip,
    userZip
  };
}
export default getZipCodes;